import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  initState,
  submitData,
} from "../../../modules/reducers/lostFound/registerLostItem";
import registerLostItemApi from "../api/registerLostItemApi";
import {
  formatDateYYYYMMDD,
  formatTimeHHMM,
  splitPhoneNumber,
} from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import decryptPhoneNumberApi from "../../../api/decrypt/decryptPhoneNumberApi";
import { getPhoneNumber } from "../../../modules/reducers/decryptPhoneNumber/decryptPhoneNumber";
import queryString from "query-string";
import { getBranchListApi } from "../../StoreNews/api/getBranchListApi";
import { findBranches } from "../../../modules/reducers/storeNews/getBranchesStoreNews";
import { addMonths, startOfMonth } from "date-fns";

const useRegisterLost = () => {
  const makeDate = () => {
    const currentDate = new Date(); // 현재 날짜와 시간을 얻습니다.
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() - 1;
    if (month === -1) {
      year -= 1;
      month = 11; // 12월
    }
    const minDate = startOfMonth(addMonths(new Date(), -1));

    return { currentDate, minDate };
  };

  const dispatch = useDispatch();
  const { currentDate, minDate } = makeDate();

  const navigate = useNavigate();
  const location = useLocation();

  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  const branchName = useSelector((state) => state.checkArsStatus.branchName);
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const brandIdARS = useSelector((state) => state.checkArsStatus.brandId);

  const phoneNumber = useSelector(
    (state) => state.decryptPhoneNumber.phoneNumber
  );
  const receiptNumber = useSelector(
    (state) => state.registerLostItem.receiptNumber
  );
  const status = useSelector((state) => state.registerLostItem.status);
  const loading = useSelector((state) => state.registerLostItem.loading);

  const branchList = useSelector(
    (state) => state.getBranchesStoreNews.branchList
  );

  const [formData, setFormData] = useState({
    branchName: "", // 점포 선택
    name: "", // 이름
    lostDate: currentDate, // 분실 일자
    phoneNumber: "", // 연락처
    lostLocation: "", // 분실 장소
    lostItemDetails: "", // 분실물품 상세 설명
    maxDate: currentDate,
    minDate: minDate
  });

  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [isFormLink, setIsFormLink] = useState({
    isFormLink: false,
    brandId: null,
  });

  const queryParams = queryString.parse(location.search);

  useEffect(() => {
    if (queryParams.brandId && branchList.length > 0) {
      setSelectedBranchId(branchList[0].id);
    }
  }, [branchList]);

  useEffect(() => {
    setSelectedBranchId(branchId);
  }, [branchId]);
  useEffect(() => {
    if (isFormLink.brandId) {
      const api = getBranchListApi({
        brandId: isFormLink.brandId,
      });
      dispatch(findBranches(api));
    }
  }, [isFormLink]);

  useEffect(() => {
    if (queryParams.brandId) {
      const brandId = queryParams.brandId;
      setIsFormLink({
        isFormLink: true,
        brandId,
      });
    } else {
      setIsFormLink({
        isFormLink: false,
        brandId: brandIdARS,
      });
    }
  }, [brandIdARS]);

  useEffect(() => {}, [formData]);

  const [showError, setShowError] = useState({
    lostDate: false,
    lostLocation: false,
    lostItemDetails: false,
  });

  useEffect(() => {
    if (isFormLink.isFormLink) {
      setFormData((prev) => ({
        ...prev,
        branchName: "",
        phoneNumber: "",
      }));
    } else if (branchName && phoneNumber && !isFormLink.isFormLink) {
      setFormData((prev) => ({
        ...prev,
        branchName,
        phoneNumber,
      }));
    }
  }, [branchName, phoneNumber, isFormLink]);

  useEffect(() => {
    if (userId && !isFormLink.isFormLink) {
      const api = decryptPhoneNumberApi();
      const data = {
        data: userId,
        audit: {
          account: "erody-front",
          api_name: "erody-front",
        },
      };
      dispatch(getPhoneNumber({ ...api, data }));
    }
  }, [userId, isFormLink]);

  useEffect(() => {
    if (receiptNumber !== null) {
      dispatch(initState());
      if (queryParams.brandId) {
        navigate(`/lost/register-completed?brandId=${queryParams.brandId}`, {
          state: { receiptNumber },
          replace: true,
        });
      } else {
        navigate(`/lost/register-completed`, {
          state: { receiptNumber },
          replace: true,
        });
      }
    }
  }, [status]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // phoneNumber 필드에 대해 유효성 검사 수행
    if (name === "phoneNumber") {
      if (/^\d*$/.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      } else {
        alert("숫자만 입력해주세요");
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

    if (value.trim() !== "") {
      setShowError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleDateChange = (date, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: date,
    }));
  };

  useEffect(() => {
    console.log(formData.lostDate);
  }, [formData]);
  const submit = () => {
    const requiredFields = [
      "name",
      "lostDate",
      "lostLocation",
      "lostItemDetails",
      "phoneNumber",
    ];
    const errors = {};
    let allFieldsValid = true;
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = true;
        allFieldsValid = false;
      } else if (
        field === "phoneNumber" &&
        (formData[field].length < 10 || formData[field].length > 11)
      ) {
        errors[field] = true;
        allFieldsValid = false;
      }
    });
    setShowError(errors);
    console.log(showError);

    if (allFieldsValid) {
      const [all, firstPart, secondPart, thirdPart] = splitPhoneNumber(
        formData.phoneNumber
      );
      const today = new Date();
      const currentDate = formatDateYYYYMMDD(today);
      const currentTime = formatTimeHHMM(today);
      const lostDate = formatDateYYYYMMDD(formData.lostDate);
      const data = {
        register_date: currentDate,
        store_code: selectedBranchId,
        empolyee_id: "p90meg",
        lose_time: currentTime,
        lose_date: lostDate,
        lose_qty: "1",
        lose_amount: 0,
        lose_place_name: formData.lostLocation,
        description: formData.lostItemDetails,
        customer_name: formData.name,
        customer_phone_number_1: firstPart,
        customer_phone_number_2: secondPart,
        customer_phone_number_3: thirdPart,
      };
      const api = registerLostItemApi();
      dispatch(submitData({ ...api, data }));
    }
  };

  const selectBranch = (branchId) => {
    setSelectedBranchId(branchId);
  };

  return {
    handleChange,
    handleDateChange,
    formData,
    showError,
    submit,
    loading,
    isFormLink,
    branchList,
    selectBranch,
    selectedBranchId,
  };
};

export default useRegisterLost;
